// extracted by mini-css-extract-plugin
export default {"preloaderholder":"App_preloaderholder__fayt7","lottie":"App_lottie__NZjFb"};